import Header from "../Component/UserEnd/Header";
import GalleryTitle from "../Component/UserEnd/GalleryTitle";
import GalleryMore from "../Component/UserEnd/GalleryMore";
import Footer from "../Component/UserEnd/Footer";

function GalleryOuter() {
    return (
        <>
            <Header />
            <GalleryTitle />
            <GalleryMore />
            <Footer />
        </>
    );
}

export default GalleryOuter;
